export default "__VITE_ASSET__Ku$OBFsT__"